module.exports = __webpack_public_path__ + "img/cool.d855c42.jpg";